import { NgModule } from 'ng-metadata/core';
import { configureMdToastProvider } from './md-toast-provider.config';
import './toast.scss';

/**
 * @ngdoc module
 * @name mw.components.toasts
 * @description
 *
 * Toasts
 */
@NgModule({
    providers: [configureMdToastProvider]
})
export class ToastModule {}



// WEBPACK FOOTER //
// ./src/lib/components/toast/toast.module.ts